import {AuthApiService} from "../auth/auth-api.service";
import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {firstValueFrom} from "rxjs";

export class PaymentRecordData {
    outletId: number;
    date: string;
    appPayments: number;
    appClips: number;
    paymentCount: number;
}

@Injectable()
export class VenueSyncService {

    constructor(private auth: AuthApiService, private http: HttpClient) {
    }

    async getPaymentRecords(venueId: string, startDate: string, endDate: string): Promise<PaymentRecordData[]> {
        return firstValueFrom(this.http.get<PaymentRecordData[]>("/fonzie/venue-sync/" + venueId + "/paymentRecords?startDate=" + startDate + "&endDate=" + endDate, {headers: this.auth.getHttpHeaderOptions()}));
    }
}
